/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from 'react';
import ModalComponent from '../../components/ModalComponent';
import '../../assets/style/Modal.css';
import ModalHeader from '../../components/ModalHeader';
import { Button, Col, Label, Row } from 'reactstrap';
import { Image } from 'react-bootstrap';
import ImagePreviewModal from './ImagePreviewModal';

interface PreviewAttachmentModalProps {
  isOpen: boolean;
  toggleModal: () => void;
  documents?: any[];
}

const PreviewAttachmentModal: React.FunctionComponent<
  PreviewAttachmentModalProps
> = ({ isOpen, toggleModal, documents }: PreviewAttachmentModalProps) => {
  const [openImagePreview, setOpenImagePreview] = useState<boolean>(false);
  const [selectedImageUrl, setSelectedImageUrl] = useState<string>('');

  const handleSelectedImage = (image: any) => {
    setSelectedImageUrl(image);
    setOpenImagePreview(true);
  };

  const toggleImageModal = () => {
    setOpenImagePreview(false);
    setSelectedImageUrl('');
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={toggleModal}
      className="modalWrapper"
      backdrop="static"
    >
      <div className="d-flex justify-content-center">
        <div className="bg-white p-2 modal-80 rounded border">
          <ModalHeader
            closeOnly={true}
            photoUrl=""
            toggle={() => {
              toggleModal();
            }}
          />
          <div className="mx-3 pb-3">
            <Label className="model-label-attachment mb-3">Attachments</Label>
            <Row>
              {documents?.length ? (
                documents?.map((item: any, index: number) => (
                  <Col xs={6} md={6} key={`attachment-key-${String(index)}}`}>
                    <div className="d-flex justify-content-center">
                      <Image
                        src={item?.filePath ?? item?.mediaPath}
                        className="attachment-image mb-4"
                        onClick={() =>
                          handleSelectedImage(item?.filePath ?? item?.mediaPath)
                        }
                      />
                    </div>
                  </Col>
                ))
              ) : (
                <p>No documents are there</p>
              )}
            </Row>
            <div className="d-flex justify-content-center mt-1 ">
              <Button
                variant="outline-primary"
                className="cl-btn-primary"
                onClick={toggleModal}
              >
                Close
              </Button>
            </div>
          </div>
        </div>
        <ImagePreviewModal
          isItUrl={true}
          isOpen={openImagePreview}
          onApproveRejectAction={(actionType: number, documentId: number) => {}}
          photoURL={selectedImageUrl}
          toggle={toggleImageModal}
        />
      </div>
    </ModalComponent>
  );
};

export default PreviewAttachmentModal;
